import * as React from 'react';
import type { FormInputEvent } from 'utils/form/Form.types';
import NoodleInput from 'components/uielements/Input';
import type { DateInputProps, DateInputState } from './DateInput.types';

class DateInput extends React.Component<DateInputProps, DateInputState> {
  constructor(props: DateInputProps) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  handleOnChange = ({ currentTarget: { value } }: FormInputEvent) => {
    const { onChange, name } = this.props;

    if (typeof value === 'string') {
      const parsedValue = this.parseValue(value).replace(/[^0-9/]/g, '');
      this.setState(
        {
          value: parsedValue,
        },
        () =>
          onChange({
            currentTarget: {
              name,
              value: parsedValue,
            },
          }),
      );
    }
  };

  addMonthLeadingZero = (value: string): string => {
    const regex = /^([1-9][/])$|^(^[2-9])$/;
    return regex.test(value) ? `0${value}` : value;
  };

  addDayLeadingZero = (value: string): string => {
    const regex = /^(\d\d[/][4-9])$|^(\d\d[/][1-3][/])$/;
    return regex.test(value) ? `${value.substring(0, 3)}0${value.substring(3)}` : value;
  };

  addFowardSlash = (value: string, prevValue = ''): string => {
    const regex = /^(0[1-9]|1[0-2])$|^(0[1-9]|1[0-2])[/](0[1-9]|[1-2][0-9]|3[0-1])$/;
    return regex.test(value) && prevValue.length < value.length ? `${value}/` : value;
  };

  avoidType = (value: string): string => {
    const regex = /^(00)|([/]00)|^(0[/]$)|[/]0[/]|[/][/]|[^0-9/]|^[/]|^\d\d[/]3[2-9]$/;
    return regex.test(value) ? value.substring(0, value.length - 1) : value;
  };

  parseValue = (value: string): string => {
    const { value: prevValue } = this.state;
    let parsedValue = this.avoidType(value);

    if (parsedValue === value) {
      parsedValue = this.addMonthLeadingZero(value);
      parsedValue = this.addDayLeadingZero(parsedValue);
      parsedValue = this.addFowardSlash(parsedValue, prevValue);
    }

    return parsedValue;
  };

  render() {
    const { value } = this.state;
    const {
      className,
      disabled,
      feedbackClass = '',
      hasDataClass = '',
      isInvalidClass = '',
      name,
      onKeyPress,
      placeholder,
    } = this.props;
    return (
      <div className={`form-input__input${feedbackClass} ${hasDataClass} ${isInvalidClass}`}>
        <NoodleInput
          className={className}
          disabled={disabled}
          maxLength='10'
          name={name}
          onChange={this.handleOnChange}
          onKeyPress={onKeyPress}
          placeholder={placeholder}
          type='text'
          value={value}
        />
        <i className='fas' />
      </div>
    );
  }
}

export default DateInput;
